import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import './styles.scss';

const DataIngestion = () => {
  const navigate = useNavigate();
  const [uploads, setUploads] = useState({ pivot: false, ci: false, bol: false, broker: false });

  const handleUpload = (type) => {
    setUploads((prev) => ({ ...prev, [type]: true }));
  };

  const allUploaded = uploads.pivot && uploads.ci && uploads.bol && uploads.broker;

  return (
    <Box className="td-ingestion-wrapper">
      <Typography sx={{ marginTop: 0, marginBottom: '8px', fontWeight: 700, fontSize: '24px', color: '#1e293b' }}>
        4-Way Data Ingestion
      </Typography>
      <Typography sx={{ color: '#64748b', fontSize: '14px', marginBottom: '32px', maxWidth: '800px' }}>
        Upload your internal compliance instructions and the raw supply chain documents. LusidPay will
        automatically map these against the Broker's filed 7501s to execute the Comprehensive Financial
        &amp; Tariff QA.
      </Typography>

      <Box className="td-upload-grid">
        <Box
          className={`td-upload-zone td-golden-record${uploads.pivot ? ' td-uploaded' : ''}`}
          onClick={() => handleUpload('pivot')}
        >
          <Typography sx={{ margin: 0, color: '#6d28d9', fontWeight: 700, fontSize: '16px' }}>
            1. DASI Pivot Table
          </Typography>
          <Typography sx={{ margin: '8px 0 0 0', color: '#8b5cf6', fontSize: '13px' }}>
            Classification Answer Key
          </Typography>
          {uploads.pivot && (
            <Typography className="td-status-msg">✓ 115 Submission Lines Parsed</Typography>
          )}
        </Box>

        <Box
          className={`td-upload-zone${uploads.ci ? ' td-uploaded' : ''}`}
          onClick={() => handleUpload('ci')}
        >
          <Typography sx={{ margin: 0, color: '#1e293b', fontWeight: 700, fontSize: '16px' }}>
            2. Commercial Invoices
          </Typography>
          <Typography sx={{ margin: '8px 0 0 0', color: '#64748b', fontSize: '13px' }}>
            Raw Financial Data
          </Typography>
          {uploads.ci && (
            <Typography className="td-status-msg">✓ AI Extracted Unit Economics</Typography>
          )}
        </Box>

        <Box
          className={`td-upload-zone${uploads.bol ? ' td-uploaded' : ''}`}
          onClick={() => handleUpload('bol')}
        >
          <Typography sx={{ margin: 0, color: '#1e293b', fontWeight: 700, fontSize: '16px' }}>
            3. Bills of Lading
          </Typography>
          <Typography sx={{ margin: '8px 0 0 0', color: '#64748b', fontSize: '13px' }}>
            Shipment Details
          </Typography>
          {uploads.bol && (
            <Typography className="td-status-msg">✓ Page 1 Sailing Dates Extracted</Typography>
          )}
        </Box>

        <Box
          className={`td-upload-zone${uploads.broker ? ' td-uploaded' : ''}`}
          onClick={() => handleUpload('broker')}
        >
          <Typography sx={{ margin: 0, color: '#1e293b', fontWeight: 700, fontSize: '16px' }}>
            4. Broker 7501s
          </Typography>
          <Typography sx={{ margin: '8px 0 0 0', color: '#64748b', fontSize: '13px' }}>
            Filed Customs Entries
          </Typography>
          {uploads.broker && (
            <Typography className="td-status-msg">✓ Broker Filings Ingested</Typography>
          )}
        </Box>
      </Box>

      {allUploaded && (
        <Box sx={{ textAlign: 'right' }}>
          <button className="td-primary-btn td-btn-green" onClick={() => navigate('/')}>
            Execute 19 CFR QA Scan →
          </button>
        </Box>
      )}
    </Box>
  );
};

export default DataIngestion;
